<img src="/assets/mockup/expenses_chart.svg" alt="">